(() => {
  'use strict';

  if (window.KynaliaVariantSubscriptionWidget) return;
  window.KynaliaVariantSubscriptionWidget = true;

  const CONFIG = {
    productPath: '/products/gland-support',
    variantPickerSelector:
      'variant-radios[data-url="/products/gland-support"]',
    appstleWidgetSelector:
      '.appstle_sub_widget[id^="appstle_subscription_widget"]',
    defaultSize: 'Under 25 lbs',
    appstleRetryDelays: [0, 75, 175, 350, 650, 1000, 1600],

    sizes: {
      'Under 25 lbs': {
        buttonLabel: 'Under 25 lbs',
        tubs: 1,
        chews: 30
      },
      '25 - 75 lbs': {
        buttonLabel: '25–75 lbs',
        tubs: 2,
        chews: 60
      },
      'Over 75 lbs': {
        buttonLabel: 'Over 75 lbs',
        tubs: 3,
        chews: 90
      }
    }
  };

  const state = {
    selectedSize: CONFIG.defaultSize,
    variants: [],
    initialized: false,
    operationToken: 0,
    syncScheduled: false
  };

  function normalizePath(path) {
    return String(path || '').replace(/\/$/, '');
  }

  function isTargetProduct() {
    return normalizePath(window.location.pathname) ===
      normalizePath(CONFIG.productPath);
  }

  function getVariantPicker() {
    return document.querySelector(CONFIG.variantPickerSelector);
  }

  function getProductScope() {
    const picker = getVariantPicker();

    return picker?.closest('[id^="MainProduct-"]') ||
      picker?.closest('.product') ||
      picker?.parentElement ||
      document;
  }

  function getAppstleWidget() {
    const scope = getProductScope();

    return scope.querySelector(CONFIG.appstleWidgetSelector) ||
      document.querySelector(CONFIG.appstleWidgetSelector);
  }

  function parseVariants() {
    const picker = getVariantPicker();
    const json = picker?.querySelector('script[type="application/json"]');

    if (!json) return state.variants;

    try {
      const variants = JSON.parse(json.textContent);
      if (Array.isArray(variants) && variants.length) {
        state.variants = variants;
      }
    } catch (error) {
      console.warn(
        '[Feinoria widget] Could not parse Shopify variant data.',
        error
      );
    }

    return state.variants;
  }

  function getVariant(size = state.selectedSize) {
    return parseVariants().find((variant) =>
      variant.option1 === size ||
      variant.title === size ||
      variant.public_title === size
    ) || null;
  }

  function getCurrency() {
    return window.Shopify?.currency?.active || 'USD';
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: getCurrency(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (_error) {
      return `$${amount.toFixed(2)}`;
    }
  }

  function formatPerChew(cents, chews) {
    return formatMoney(Math.round(Number(cents || 0) / chews));
  }

  function getPlanData() {
    const variant = getVariant();
    const meta = CONFIG.sizes[state.selectedSize];

    return {
      variant,
      meta,
      activePrice: Number(variant?.price || 0)
    };
  }

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function buildWidget() {
    if (document.querySelector('.kynalia-widget')) return;

    const picker = getVariantPicker();
    if (!picker) return;

    const widget = document.createElement('div');
    widget.className = 'kynalia-widget';
    widget.setAttribute('data-kynalia-widget', 'variant-subscription');

    widget.innerHTML = `
      <section class="kynalia-dog-size" aria-labelledby="kynalia-dog-size-title">
        <div class="kynalia-dog-size__title" id="kynalia-dog-size-title">
          Choose Dog Size:
        </div>
        <div class="kynalia-dog-size__options" role="group" aria-label="Choose dog size">
          ${Object.entries(CONFIG.sizes).map(([nativeValue, size]) => `
            <button
              class="kynalia-dog-size__button"
              type="button"
              data-kynalia-size="${nativeValue}"
              aria-pressed="false"
            >${size.buttonLabel}</button>
          `).join('')}
        </div>
      </section>

      <section class="kynalia-plan-card" aria-live="polite">
        <div class="kynalia-plan-card__summary">
          <span class="kynalia-plan-card__radio" aria-hidden="true">
            <span></span>
          </span>

          <div class="kynalia-plan-card__information">
            <div class="kynalia-plan-card__heading">
              <span class="kynalia-plan-card__title"></span>
            </div>
            <div class="kynalia-plan-card__subtitle"></div>
          </div>

          <div class="kynalia-plan-card__price-information">
            <div class="kynalia-plan-card__price"></div>
          </div>
        </div>

      </section>
    `;

    picker.insertAdjacentElement('beforebegin', widget);
  }

  function visuallyHideNativeControls() {
    const picker = getVariantPicker();
    const appstle = getAppstleWidget();

    if (picker) picker.classList.add('kynalia-native-control');
    if (appstle) appstle.classList.add('kynalia-native-control');
  }

  function renderWidget() {
    const widget = document.querySelector('.kynalia-widget');
    if (!widget) return;

    const data = getPlanData();
    if (!data.variant || !data.meta) return;

    widget.classList.add('kynalia-is-one-time');

    widget.querySelectorAll('.kynalia-dog-size__button').forEach((button) => {
      const isActive = button.dataset.kynaliaSize === state.selectedSize;
      const nativeInput = getVariantPicker()?.querySelector(
        `input[name="Dog Size"][value="${CSS.escape(button.dataset.kynaliaSize)}"]`
      );

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
      button.disabled = Boolean(nativeInput?.disabled);
    });

    setText(
      widget.querySelector('.kynalia-plan-card__title'),
      `${data.meta.tubs} ${data.meta.tubs === 1 ? 'Tub' : 'Tubs'}`
    );

    setText(
      widget.querySelector('.kynalia-plan-card__subtitle'),
      `${data.meta.chews} Chews · 30-Day Supply · ${formatPerChew(
        data.activePrice,
        data.meta.chews
      )}/chew`
    );

    setText(
      widget.querySelector('.kynalia-plan-card__price'),
      formatMoney(data.activePrice)
    );

  }

  function getNativeVariantInput(size) {
    return getVariantPicker()?.querySelector(
      `input[name="Dog Size"][value="${CSS.escape(size)}"]`
    ) || null;
  }

  function dispatchNativeSelection(input) {
    if (!input) return;

    input.click();

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyNativePurchaseSelection(token) {
    if (token !== state.operationToken) return false;

    clearSellingPlanInputs();

    const appstle = getAppstleWidget();
    if (!appstle) return false;

    const input = [...appstle.querySelectorAll('input[name="selling_plan"]')]
      .find((candidate) => candidate.value === '');

    if (!input) return false;

    if (!input.checked) dispatchNativeSelection(input);
    clearSellingPlanInputs();
    return input.checked;
  }

  function clearSellingPlanInputs() {
    getProductScope().querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.querySelectorAll('[name="selling_plan"]').forEach((input) => {
        if (input.type !== 'radio' && input.type !== 'checkbox') {
          input.value = '';
        }
      });
    });
  }

  function queuePurchaseSelection(token = state.operationToken) {
    CONFIG.appstleRetryDelays.forEach((delay) => {
      window.setTimeout(() => {
        if (token !== state.operationToken) return;

        visuallyHideNativeControls();
        applyNativePurchaseSelection(token);
      }, delay);
    });
  }

  function selectSize(size) {
    if (!CONFIG.sizes[size]) return;

    state.selectedSize = size;
    const token = ++state.operationToken;
    renderWidget();

    const nativeInput = getNativeVariantInput(size);
    if (nativeInput && !nativeInput.checked) {
      dispatchNativeSelection(nativeInput);
    }

    queuePurchaseSelection(token);
  }

  function bindEvents() {
    if (
      document.documentElement.dataset.kynaliaWidgetEventsBound === 'true'
    ) {
      return;
    }

    document.documentElement.dataset.kynaliaWidgetEventsBound = 'true';

    document.addEventListener('click', (event) => {
      const sizeButton = event.target.closest('.kynalia-dog-size__button');

      if (sizeButton) {
        selectSize(sizeButton.dataset.kynaliaSize);
        return;
      }

    });

    document.addEventListener('submit', (event) => {
      if (getProductScope().contains(event.target) &&
          event.target.matches('form[action*="/cart/add"]')) {
        clearSellingPlanInputs();
      }
    }, true);

    document.addEventListener('formdata', (event) => {
      if (getProductScope().contains(event.target) &&
          event.target.matches('form[action*="/cart/add"]')) {
        event.formData.delete('selling_plan');
      }
    }, true);

    document.addEventListener('change', (event) => {
      const input = event.target;

      if (
        input.matches?.(
          `${CONFIG.variantPickerSelector} input[name="Dog Size"]`
        ) &&
        input.checked &&
        CONFIG.sizes[input.value]
      ) {
        state.selectedSize = input.value;
        renderWidget();
      }
    });
  }

  function sync() {
    if (!isTargetProduct()) return;

    const picker = getVariantPicker();
    if (!picker) return;

    parseVariants();
    buildWidget();
    visuallyHideNativeControls();
    bindEvents();
    renderWidget();

    if (!state.initialized) {
      state.initialized = true;
      selectSize(CONFIG.defaultSize);
    } else {
      queuePurchaseSelection(state.operationToken);
    }
  }

  function scheduleSync() {
    if (state.syncScheduled) return;

    state.syncScheduled = true;

    window.requestAnimationFrame(() => {
      state.syncScheduled = false;
      sync();
    });
  }

  const observer = new MutationObserver((mutations) => {
    const relevantMutation = mutations.some((mutation) => {
      const changedInsideAppstle = mutation.target.closest?.(
        CONFIG.appstleWidgetSelector
      );

      if (changedInsideAppstle) return true;

      return [...mutation.addedNodes].some((node) =>
        node.nodeType === Node.ELEMENT_NODE &&
        (
          node.matches?.(CONFIG.variantPickerSelector) ||
          node.matches?.(CONFIG.appstleWidgetSelector) ||
          node.querySelector?.(CONFIG.variantPickerSelector) ||
          node.querySelector?.(CONFIG.appstleWidgetSelector)
        )
      );
    });

    if (relevantMutation) scheduleSync();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, {
      once: true
    });
  } else {
    scheduleSync();
  }
})();
